import { t } from 'frontend/js/modules/infra/i18n';
export var getLanguageName = function (language) {
    switch (language) {
        case 'en':
            return "".concat(t('settings:language_settings.english'), " - English");
        case 'es':
            return "".concat(t('settings:language_settings.spanish'), " - Espa\u00F1ol");
        default:
            return '';
    }
};
